// src/components/OpponentInfo.js
import React from 'react';
import './OpponentInfo.css';

function OpponentInfo({ opponent }) {
  if (!opponent) return null;

  return (
    <div className="opponent-info">
      <div className="opponent-header">
        <div className="opponent-avatar">👤</div>
        <div className="opponent-details">
          <h3>{opponent.nickname}</h3>
          <div className="opponent-stats">
            <span className="stat-item">
              <span className="stat-icon">🃏</span>
              <span>{opponent.hand_count} 张手牌</span>
            </span>
            <span className="stat-item">
              <span className="stat-icon">🐫</span>
              <span>{opponent.camels} 只骆驼</span>
            </span>
            <span className="stat-item">
              <span className="stat-icon">🪙</span>
              <span>{opponent.token_count} 个代币</span>
            </span>
            <span className="stat-item stat-score">
              <span className="stat-icon">⭐</span>
              <span>{opponent.score} 分</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OpponentInfo;
